import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { serverTimestamp } from 'firebase/firestore';
import { AngularFirestore, Query } from '@angular/fire/compat/firestore';
import { StateService } from '@shared/services/state.service';
import { User } from '../../models/message';

@Injectable({
  providedIn: 'root'
})
export class ConversationService {
  constructor(
    private readonly firestore: AngularFirestore,
    private readonly auth: AuthService,
    private stateService: StateService,
  ) {}

  private get roomId(): string | number | null {
    return this.stateService.roomId;
  }

  public async sendMessage(text: string) {
    const user = this.auth.currentUser;
    if (!!user) {
      return this.addMessageToConversation(user, 'text', text);
    }
  }

  public getMessages(): Query<any> {
    console.log('firestore::Messages::getMessages');
    return this.firestore.collection('Messages').ref
      .where('roomId', '==', this.roomId)
      .orderBy('sentAt', 'asc')
      .limitToLast(50);
  }

  public notify(): Query<any> {
    console.log('firestore::Messages::notify');
    return this.firestore.collection('Messages').ref
      .where('roomId', '==', this.roomId)
      .where('sentAt', '>', new Date())
      .orderBy('sentAt', 'asc')
      .limitToLast(11);
  }

  public getLatestMessage(): Query<any> {
    console.log('firestore::Messages::latest');
    return this.firestore.collection('Messages').ref
      .where('roomId', '==', this.roomId)
      .where('sentAt', '>', new Date())
      .orderBy('sentAt', 'asc')
      .limitToLast(1);
  }

  private async addMessageToConversation(user: User, type: 'text' | 'member:joined', text?: string) {
    await this.firestore.collection('Messages')
      .add({
        roomId: this.roomId,
        sentAt: serverTimestamp(),
        user: {
          uid: user.id,
          displayName: user.displayName,
          photoURL: user.photoURL,
        },
        type,
        text,
      });
  }
}
